export default {"src":"/_next/static/media/collateral.cc146bce.svg","height":152,"width":133};